
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise/insights",
      function () {
        return require("private-next-pages/expertise/insights/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise/insights"])
      });
    }
  